<template>
  <transition name="zoomIn">
    <div class="mask">
      <div class="show-box">
        <div class="txt">
          <p>
            赠送{{ data.name }}，将消耗<i>{{data.coin }}枚金币</i>，确定要继续赠送吗？
          </p>
        </div>
        <div class="btn-box">
          <div class="cursor" @click="cancelE">放弃</div>
          <div class="cursor" @click="defaultAlert">确定</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  created() {},
  methods: {
    //=>取消事件
    cancelE() {
      this.$emit("cancelEvent");
    },
    //确定事件
    defaultAlert() {
      this.$emit("ensure");
    },
  },
};
</script>
<style lang="less" rel="stylesheet/stylus" scoped>
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 16px;
}
.show-box {
  width: 436px;
  border-radius: 15px;
  text-align: center;
  background: #ffffff;
  .txt {
    padding: 40px 24px;
    width: 436px;
    box-sizing: border-box;
    p {
      font-size: 25px;
      color: #004466;
      line-height: 36px;
	}
	i{
		color: #e19417;
		background: url('../../../../assets/img/common/coin.png') no-repeat left center;
		background-size:28px;
		padding-left: 30px;
	}
  }
  .btn-box {
    display: flex;
    flex-direction: row;
    height: 80px;
    border-top: 1px solid #9ebfc8;
    div {
      flex: 1;
      box-sizing: border-box;
      font-size: 24px;
      color: #0073ae;
      line-height: 80px;
      &:hover {
        color: #66b8e2;
      }
    }
    div:nth-child(2) {
      box-sizing: border-box;
      border-left: 1px solid #9ebfc8;
      line-height: 80px;
    }
  }
}
.zoomIn-enter-active,
.zoomIn-enter {
  animation: zoomIn 0.3s cubic-bezier(0.645, 0.045, 0.15, 1);
}
.zoomIn-leave-active, .zoomIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  animation: zoomIn 0.3s reverse cubic-bezier(0.645, 0.045, 0.15, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/video/sendGift/alert.vue